import SvgIcon, { SvgIconProps } from "./SvgIcon";

const SupportIcon: React.FC<SvgIconProps> = ({
  variant = "contained",
  ...props
}) => {
  return (
    <SvgIcon {...props}>
      {variant == "contained" ? (
        <path d="M3 20C1.89543 20 1 19.1046 1 18V14C1 12.8954 1.89543 12 3 12H4C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12H21C22.1046 12 23 12.8954 23 14V18C23 19.1046 22.1046 20 21 20H19C18.4477 20 18 19.5523 18 19V12C18 8.7616 15.4344 6.12243 12.2249 6.00414L12 6C8.7616 6 6.12243 8.56557 6.00414 11.7751L6 12V19C6 19.5523 5.55228 20 5 20H3Z" />
      ) : (
        <path d="M3 20C1.89543 20 1 19.1046 1 18V14C1 12.8954 1.89543 12 3 12H4C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12H21C22.1046 12 23 12.8954 23 14V18C23 19.1046 22.1046 20 21 20H19C18.4477 20 18 19.5523 18 19V12C18 8.7616 15.4344 6.12243 12.2249 6.00414L12 6C8.7616 6 6.12243 8.56557 6.00414 11.7751L6 12V19C6 19.5523 5.55228 20 5 20H3ZM21 14H20V18H21V14ZM4 14H3V18H4V14Z" />
      )}
    </SvgIcon>
  );
};

export default SupportIcon;
